import Reveal from '@/components/base/Reveal';

export default function BrandStatement() {
  return (
    <section className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-white/10">
            <div className="relative w-full  aspect-[16/9] md:aspect-[21/9]">
              <img
                src="/assets/images/josh-profile-image-1.png"
                alt="Josh Hastings standing with confidence in a premium dark setting"
                title="Josh Hastings — Marketing Strategist"
                className="absolute inset-0 justify-self-center opacity-40 h-full object-cover object-top opacity-70"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50/85" />
            </div>

            <div className="absolute inset-0 flex items-center justify-center p-6 md:p-12 text-center">
              <div className="max-w-3xl">
                <span className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/20 text-primary-400">
                  <i className="ri-double-quotes-l text-2xl"></i>
                </span>
                <p className="mt-6 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
                  &ldquo;The goal isn&rsquo;t more marketing. The goal is a
                  better business because your marketing works.&rdquo;
                </p>
                <div className="mt-6">
                  <p className="font-heading font-semibold text-foreground-950">
                    Josh Hastings
                  </p>
                  <p className="text-sm text-foreground-600">
                    Marketing Strategist
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
